import { render, staticRenderFns } from "./Provision.vue?vue&type=template&id=60da286a"
import script from "./Provision.vue?vue&type=script&lang=js"
export * from "./Provision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports